module.exports = __webpack_public_path__ + "static/media/rtds team2-01.214c4623.png";


//////////////////
// WEBPACK FOOTER
// ./src/rtds team2-01.png
// module id = 201
// module chunks = 0